import { addNavMenuItem, registerBulkAction, registerCustomDetailComponent } from "@bb-vendure/admin-ui/core";
import { SingleAssetPickerComponent } from "./components/single-asset-picker/single-asset-picker.component";
import { SmsShippingSettingsComponent } from "./components/sms-shipping-settings/sms-shipping-settings.component";
import { EventStockAlertSettingsComponent } from "./components/event-stock-alert-settings/event-stock-alert-settings.component";
import { EventListSettingsComponent } from "./components/event-list-settings/event-list-settings.component";

export default [
  registerCustomDetailComponent({
    locationId: 'global-settings-detail',
    component: SingleAssetPickerComponent,
  }),
  // NY-13: shipping SMS on/off toggles (B2B/B2C)
  registerCustomDetailComponent({
    locationId: 'global-settings-detail',
    component: SmsShippingSettingsComponent,
  }),
  // Event stock shortage: alert recipients + auto-purchase toggle
  registerCustomDetailComponent({
    locationId: 'global-settings-detail',
    component: EventStockAlertSettingsComponent,
  }),
  // Event list: hide events N days after they end
  registerCustomDetailComponent({
    locationId: 'global-settings-detail',
    component: EventListSettingsComponent,
  }),
];
